module.exports = __webpack_public_path__ + "assets/img/icon_xxjs.9f289205.png";